import { Box, Paper, Skeleton, Stack } from '@mui/material';
import { memo } from 'react';
import { ItemCardSkeleton } from './ItemCardSkeleton';

type Props = {
  rows: number;
};

export const InstancesTableSkeleton = memo(({ rows }: Props) => {
  return (
    <Paper elevation={2}>
      <Stack>
        <Box sx={{ px: 2, py: 1.5 }}>
          <Skeleton width={200} height={48} />
        </Box>
        <Stack sx={{ flexGrow: 1, overflow: 'scroll' }}>
          {Array(rows)
            .fill('')
            .map((_, index) => (
              <ItemCardSkeleton key={index}>
                <Stack direction="row" spacing={1.5} alignItems="start" sx={{ width: 1 }}>
                  <Skeleton height={32} width={40} />
                  <Stack sx={{ width: 1, pt: 0.5 }}>
                    <Skeleton height={20} width="100%" />
                    <Skeleton height={20} width="100%" />
                    <Skeleton height={20} width="40%" />
                  </Stack>
                </Stack>
              </ItemCardSkeleton>
            ))}
        </Stack>
        <Box sx={{ p: 2 }}>
          <Skeleton width="100%" height={32} />
        </Box>
      </Stack>
    </Paper>
  );
});
